import Vue from 'vue';
import Utils from '../../../utils';

export default {
    /**
     * 获取收费项信息
     */
    get(orderMasterUuid) {
        const url = `${window.$MIDE_CONFIG.apiUrlRoot}/api/organization-order-masters/${orderMasterUuid}`;
        return Vue.$http.get(url).then(Vue.$http.$success).catch(Vue.$http.$fail);
    },
    /**
     * 获取交费项学生及其订单
     */
    listStudents(orderMasterUuid, mobile) {
        const { apiUrlRoot } = window.$MIDE_CONFIG;
        const url = `${apiUrlRoot}/api/organization-order-masters/${orderMasterUuid}/students/organization-orders?mobile=${mobile}`;
        return Vue.$http.get(url).then(Vue.$http.$success).catch(Vue.$http.$fail);
    },
    /**
     * 订单详情
     */
    orderDetails(orderMasterUuid, studentUuid) {
        const { apiUrlRoot } = window.$MIDE_CONFIG;
        const query = { studentUuid, ensureUser: 1 };
        const url = `${apiUrlRoot}/api/organization-order-masters/${orderMasterUuid}/organization-orders${Utils.query.queryString(query)}`;
        return Vue.$http.get(url).then(Vue.$http.$success).catch(Vue.$http.$fail);
    },
    /**
     * 微信支付下单
     */
    getWxpayOrder(orderMasterUuid, data) {
        const { apiUrlRoot } = window.$MIDE_CONFIG;
        const url = `${apiUrlRoot}/api/organization-order-masters/${orderMasterUuid}/organization-orders/wxpay`;
        return Vue.$http.post(url, data).then(Vue.$http.$success).catch(Vue.$http.$fail);
    },
    /**
     * 支付宝下单
     */
    getAlipayOrder(orderMasterUuid, data) {
        const { apiUrlRoot } = window.$MIDE_CONFIG;
        const url = `${apiUrlRoot}/api/organization-order-masters/${orderMasterUuid}/organization-orders/alipay`;
        return Vue.$http.post(url, data).then(Vue.$http.$success).catch(Vue.$http.$fail);
    },

    /**
     * 课程订单详情
     *
     * */
    goodsDetails(studentUuid, goodsUuid) {
        const url = `${window.$MIDE_CONFIG.apiUrlRoot}/api/mide-coin-goods/students/${studentUuid}/mide-coin-goods/${goodsUuid}`;
        return Vue.$http.get(url).then(Vue.$http.$success).catch(Vue.$http.$fail);
    },

    /**
     * 下单
     *
     * */
    getOrder(data) {
        const url = `${window.$MIDE_CONFIG.apiUrlRoot}/api/mide-coin-orders`;
        return Vue.$http.post(url, data).then(Vue.$http.$success).catch(Vue.$http.$fail);
    },
};
